import { HttpErrorResponse } from '@angular/common/http';
import { AnnualReportMetaInformationDTO } from '@modeso/aumico-lib-annualreport-fe';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { TaskMetaInformation } from '../../../../aumico-lib-cpmm-fe/src/lib';
import { ProjectMetaInformationDto } from '../dtos/project-meta-information-dto.interface';
import { ProjectStatus } from '../enums/project-status.enum';
import { ProjectsFilter } from '../interfaces/projects-filter.interface';

export const ProjectsOverviewActions = createActionGroup({
    source: 'Projects',
    events: {
        'Load Projects Overview': props<{ filter?: ProjectsFilter }>(),
        'Projects Overview Loaded': props<{
            response: { projectsMetaInformation: ProjectMetaInformationDto[]; totalCount: number };
        }>(),
        'Projects Overview Load Failure': props<{ error: HttpErrorResponse }>(),

        'Fetch Projects List': props<{ filter?: ProjectsFilter }>(),
        'Projects List Fetched': props<{
            response: { projectsMetaInformation: ProjectMetaInformationDto[]; totalCount: number };
        }>(),
        'Projects List Fetch Failure': props<{ error: HttpErrorResponse }>(),

        'Load More Projects': props<{ filter?: ProjectsFilter }>(),
        'More Projects Loaded': props<{
            response: { projectsMetaInformation: ProjectMetaInformationDto[]; totalCount: number };
        }>(),
        'More Projects Load Failure': props<{ error: HttpErrorResponse }>(),

        'Update Project Status': props<{ projectId: string; status: ProjectStatus; updateTasks: boolean; mandateManagementTaskIds?: string[]; closingSectionIds?: string[] }>(),
        'Project Status Updated': props<{
            response: ProjectMetaInformationDto;
        }>(),
        'Project Status Update Failure': props<{ error: HttpErrorResponse }>(),

        'Bulk Update Project Status': props<{ projectIds: string[]; status: ProjectStatus; updateTasks: boolean; mandateManagementTaskIds?: string[]; closingSectionIds?: string[] }>(),
        'Bulk Project Status Updated': props<{
            response: ProjectMetaInformationDto[];
        }>(),
        'Bulk Update Project Status Failure': props<{ error: HttpErrorResponse }>(),

        'Delete Project': props<{ projectId: string }>(),
        'Project Deleted': props<{
            response: string;
        }>(),
        'Project Delete Failure': props<{ error: HttpErrorResponse; projectId?: string }>(),

        'Bulk Delete Projects': props<{ projectIds: string[]; filter: ProjectsFilter }>(),
        'Bulk Projects Deleted': props<{
            deletedIds: string[];
            warnings: { projectId: string; dependentReports: string[] }[];
        }>(),
        'Bulk Projects Delete Failure': props<{ error: HttpErrorResponse }>(),
        'Confirm Bulk Delete With Dependencies': props<{ projectIds: string[]; filter: ProjectsFilter }>(),
        'Clear Bulk Delete Warnings': emptyProps(),

        'Set Active Project Id': props<{ projectId: string }>(),
        'Clear Active Project Id': emptyProps(),

        'Fetch Project Id By Annual Report Meta Info Id': props<{ annualReportMetaId: string }>(),
        'Project Id By Annual Report Meta Info Id Fetched': props<{
            projectId: string | null;
        }>(),
        'Project Id By Annual Report Meta Info Id Fetch Failure': props<{ error: HttpErrorResponse }>(),

        'Fetch Project Data by Project Id': props<{
            projectId: string;
        }>(),
        'Project Data By Project Id Fetched': props<{
            projectId: string | null;
            projectMetaData: ProjectMetaInformationDto | null;
            annualReportMetaInfo: AnnualReportMetaInformationDTO | null;
        }>(),
        'Project Data By Project Id Fetch Failure': props<{ error: HttpErrorResponse }>(),

        'Update Project WorkflowData for Task': props<{
            projectId: string;
            taskId: string;
            task: TaskMetaInformation;
        }>(),
        'Project WorkflowData for Task Updated': emptyProps(),
        'Project WorkflowData for Task Failure': props<{ error: HttpErrorResponse }>(),

        'Update WorkflowData For all Tasks By Section Id': props<{
            projectId: string;
            sectionId: string;
            tasks: TaskMetaInformation[];
        }>(),
        'WorkflowData For all Tasks By Section Id Updated': emptyProps(),
        'WorkflowData For all Tasks By Section Id Update Failure': props<{ error: HttpErrorResponse }>(),

        'Reset Projects Overview State': emptyProps(),
    },
});
